import React, { use, useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import star from "../../../../assets/icons/star.svg";
import taka from "../../../../assets/icons/taka.svg";
import "swiper/css";
import { gsap } from "gsap";
import { Link } from "react-router";
const Hero = ({ Data }) => {
  const allRooms = Data.flatMap((hotel) => hotel.rooms);
  // const lowestPrice = Math.min(...allRooms.map((room) => room.discountedPrice));
  const highestPrice = Math.max(
    ...allRooms.map((room) => room.discountedPrice),
  );
  const maxDiscount = Math.max(...allRooms.map((room) => room.discount));
  const roomsRef = useRef(null);
  const hotelInfoRef = useRef(null);
  useEffect(() => {
    if (!Data.length) return;

    const ctx = gsap.context(() => {
      gsap.from(".roomsAni", {
        opacity: 0,
        y: 50,
        duration: 0.8,
        delay: 0.5,
        stagger: 0.2,
        ease: "power3.out",
      });
      gsap.from(hotelInfoRef.current, {
        x: -80,
        opacity: 0,
        duration: 0.8,
        delay: 0.5,
      });
    });

    return () => ctx.revert();
  }, [Data]);
  return (
    <>
      {Data.length > 0 ? (
        <div>
          <div className="w-full h-[300px] lg:h-[450px] rounded-3xl overflow-hidden">
            <Swiper
              className=""
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay]}
            >
              {Data && (
                <>
                  {Data.map((item, index) => {
                    const lowestPrice = item.rooms?.length
                      ? Math.min(
                          ...item.rooms.map((room) => room.discountedPrice),
                        )
                      : 0;
                    return (
                      <SwiperSlide key={index}>
                        <div className="w-full h-[300px] lg:h-[500px] ">
                          <div className="relative h-[300px] lg:h-[500px]">
                            <Link
                              to={`/hotel/details/${item.id}/${item.hotelName
                                .toLowerCase()
                                .replace(/ /g, "-")}`}
                            >
                              <img
                                src={item.images[0].imageLink}
                                alt=""
                                className="w-full h-full object-cover object-center"
                              />
                            </Link>
                            <div
                              ref={hotelInfoRef}
                              className="absolute top-5 left-5 px-1 lg:px-4 py-2 lg:py-3 h-auto w-auto bg-gray-300 rounded-md bg-clip-padding backdrop-filter backdrop-blur-sm bg-opacity-50 border border-gray-100"
                            >
                              <div className="flex justify-center lg:justify-start items-center space-x-0 lg:space-x-4">
                                <div className="hidden lg:block w-10 h-10 lg:w-20 bg-white rounded-lg overflow-hidden">
                                  <img
                                    src={item.hotelLogo}
                                    alt=""
                                    className="h-full w-full object-contain object-center "
                                  />
                                </div>
                                <div>
                                  <h1 className="text-xs lg:text-md font-bold uppercase  bg-gradient-to-t from-blue-500 to-blue-900 bg-clip-text text-transparent text-nowrap">
                                    {item.hotelName}
                                  </h1>
                                  <div className="flex justify-center lg:justify-start items-center space-x-3">
                                    <div className="flex items-center space-x-1 w-fit bg-white px-1 py-0.5 rounded-md">
                                      <div>
                                        <img
                                          className="w-3"
                                          src={star}
                                          alt="rating"
                                        />
                                      </div>
                                      <div>
                                        <p className="text-xs text-black/50">
                                          {item.propertyStar}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="flex items-center space-x-1 w-fit bg-white/50 px-1 py-0.5 rounded-md">
                                      <div>
                                        <img
                                          width={15}
                                          src={taka}
                                          alt="rating"
                                        />
                                      </div>
                                      <div>
                                        <p className="text-[10px] lg:text-[10px] font-bold text-black/50">
                                          Starts
                                          <span className="text-xs lg:text-sm  font-bold">
                                            ৳{lowestPrice}
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              ref={roomsRef}
                              className="absolute hidden lg:block bottom-0 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50"
                            >
                              <div className="flex gap-3">
                                {item &&
                                  item?.rooms.slice(0, 5).map((item, index) => {
                                    return (
                                      <div
                                        key={index}
                                        className="roomsAni  w-[120px] h-[120px] rounded-lg overflow-hidden relative drop-shadow-lg cursor-pointer"
                                      >
                                        <img
                                          src={item?.images[0]?.imageLink}
                                          alt={item.roomName}
                                          className="w-full h-full object-cover object-center"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-b from-slate-50/0 to-black/80 w-full h-full"></div>
                                        <div className="w-full absolute bottom-1 left-0 z-1 p-0.5 text-center flex flex-col items-center gap-1">
                                          <p className="text-[10px] text-white">
                                            {item.roomName}
                                          </p>
                                          <p className="text-xs font-bold text-white">
                                            ৳{item.discountedPrice}
                                          </p>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </>
              )}
            </Swiper>
          </div>
        </div>
      ) : (
        <div className="w-full h-[300px] lg:h-[450px] rounded-3xl overflow-hidden">
          <div className="w-full h-full bg-gray-200 animate-pulse rounded-3xl relative">
            {/* Top info box skeleton */}
            <div className="absolute top-5 left-5 px-4 py-3 bg-gray-300/50 backdrop-blur-sm rounded-md">
              <div className="flex items-center space-x-4">
                {/* Logo skeleton */}
                <div className="hidden lg:block w-20 h-20 bg-gray-300 rounded-lg"></div>

                {/* Text skeleton */}
                <div className="flex flex-col space-y-2">
                  <div className="w-32 h-4 bg-gray-300 rounded-md"></div>

                  <div className="flex space-x-3">
                    <div className="w-16 h-5 bg-gray-300 rounded-md"></div>
                    <div className="w-20 h-5 bg-gray-300/70 rounded-md"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Hero;
